import ACTION_TYPE from "./type.action";
import knowledgeService from "../services/knowledge.service";

export const updateKnowledgeScore = (nodeId) => async dispatch => {
    const studentId = localStorage.getItem("kneuraId");
    const { hierarchy, scores } = await knowledgeService.getReport(studentId, nodeId);
    dispatch({
        type: ACTION_TYPE.UPDATE_KNOWLEDGE_REPORT,
        payload: { hierarchy, scores }
    });
};

